import styled from 'styled-components';

export const Container = styled.div`
  .btn-management {
    border: solid 1px ${(props) => props.theme.$gray400} !important;
    color: ${(props) => props.theme.$gray600} !important;
    background: ${(props) => props.theme.$white};
    line-height: 14px;

    &:hover,
    &.active {
      background-color: ${(props) => props.theme.$primary} !important;
      border-color: ${(props) => props.theme.$primary} !important;
      color: ${(props) => props.theme.$white} !important;
    }
  }
`;
